const getters = {
  getCommunicationData: (state) => {
    return state.communications;
  },
  getPlanListData: (state) => {
    return state.planLists;
  },
  getGeneralMasterData(state) {
    return state.generalMaster;
  },
  getCreateScheduleForm(state) {
    return state.createScheduleForm;
  },
  getScheduleDetail(state) {
    return state.scheduleSectionData;
  },
  getPayoutCommunicationDropDownData(state) {
    return state.payoutCommunicationDropDownData;
  },
  getPartialPayoutDateItemDataData(state) {
    return state.partialPayoutDateItemData;
  },
  getPreviousPayoutCommForProgData(state) {
    return state.previousPayoutCommunicationsForProgramData;
  },
  getStorePreviousPastCommu(state) {
    return state.storePreviousPastCommu;
  },
  getPayoutCommInProgressAsync(state) {
    return state.payoutCommInProgressAsync;
  }
};

export default getters;
